// @flow

import { connect } from 'react-redux';
import React from 'react';

import { createWithResources } from 'client/actions/user';

import AccountContainer from './accountContainer';

const FORM_TYPE = 'create';

const mapStateToProps: Object = state => ({
  partnerName: state.partnerName,
});

function bindSubmitHandler(props) {
  const { partnerName } = props;
  return ({ email, password, redirect, source }) =>
    props
      .createWithResources({
        email,
        password,
        source,
        apps: [],
        members: [],
        partnerName,
      })
      .then(() => window.location.replace(redirect));
}

const AccountPage = props => (
  <AccountContainer {...props} formType={FORM_TYPE} onSubmit={bindSubmitHandler(props)} />
);

export default connect(mapStateToProps, {
  createWithResources,
})(AccountPage);
